import { formatCurrency } from "@/utils/formatEuro";

import type { AuctionCar } from "@/types/auctions";
import type { Currency } from "@/types/currency";

export function calculateEstimate(
  car: AuctionCar,
  currency: Currency,
  type: "estimate" | "carburate" = "estimate"
) {
  let low = 0;
  let high = 0;

  if (type === "estimate") {
    low = car.estimate_low ?? 0;
    high = car.estimate_high ?? 0;
  } else if (type === "carburate") {
    low = car.estimate_carburate_low ?? 0;
    high = car.estimate_carburate_high ?? 0;
  }

  if (low && high) {
    return `${formatCurrency(low, currency.code)} - ${formatCurrency(high, currency.code)}`;
  } else if (low) {
    return formatCurrency(low, currency.code);
  } else if (high) {
    return formatCurrency(high, currency.code);
  } else {
    return "-";
  }
}
